module.exports = __webpack_public_path__ + "img/bg_avatar_female_41.6b901ed5.png";